export function getProductImage(url: string, parameters: string, seo: string) {
  if (!url) {
    return ''
  }

  if (typeof seo === 'undefined') {
    return parameters ? url + '?' + parameters : url
  }

  seo = stringToSlug(seo || '')

  if (url.includes(seo) && url.includes(parameters)) {
    return url
  }

  const parts = url.split('.')
  const extension = parts.pop()

  url = parts.join('.') + '/' + seo + '.' + extension + '?sf&' + parameters

  return url
}
